import { ReportsApi, useAPIAction, useAPIQuery } from "melco-shared-logic";
import { StatisticsConfig } from "./useStatistics";
import { useCallback } from "react";

export const useGetStatistics = (dataConfig?: StatisticsConfig) => {
  const [getUserData] = useAPIAction(
    ReportsApi,
    async (api) => {
      const data = await api.reportsSearch({
        startDate: dataConfig?.startTimestamp ?? undefined,
        endDate: dataConfig?.endTimestamp ?? undefined,
        designList:
          dataConfig?.designsFilter?.map((df) => df?.value).join(",") ??
          undefined,
        groupList:
          dataConfig?.machineGroupsFilter?.map((mgf) => mgf?.value).join(",") ??
          undefined,
        isGrouped: dataConfig?.grouped ?? undefined,
      });

      return {
        successMessages: [],
        data,
      };
    },
    {
      //defaultApiConfigOptions: { impersonationForId: currentUser?.userId },
      translationPrefix: "",
    }
  );

  return useCallback(async () => {
    try {
      const res = await getUserData();
      return res;
    } catch (e) {
      // exception already handled in useAPIAction
    }
  }, [getUserData]);
};
